<!-- Reusable Components -->
<ng-template #buyNow>
  <button *ngIf="productResponse.inventory || !utils.getUserPicode()" class="primaryBtn pdpButton" id="buyNow"
    alt="Buy Now | Luminous" (click)="buynowClicked()">
    Buy Now
  </button>
</ng-template>

<ng-template #loadChart>
  <table class="table mb-5"
    *ngIf="productResponse && productResponse.appliances && productResponse.appliances.length">
    <thead>
      <tr>
        <th scope="col">Appliances/Electronics</th>
        <th scope="col text-center" colspan="2">No. of Appliances used at the time of power cut</th>
      </tr>
      <tr>
        <th scope="col"></th>
        <th scope="col">A</th>
        <th scope="col">B</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let info of productResponse?.appliances  || []">
        <td>{{info.applianceName}}{{info.watt}}W </td>
        <td >{{info.caseA?info.caseA:''}}</td>
        <td >{{info.caseB?info.caseB:''}}</td>
      </tr>
      <tr
        *ngIf="productResponse && productResponse.loadChartList && productResponse.loadChartList.totalWatt && productResponse.loadChartList.totalWatt.caseA">
        <td>Total Watt (Consumption)</td>
        <td>{{productResponse.loadChartList.totalWatt.caseA?productResponse.loadChartList.totalWatt.caseA:''}}
        </td>
        <td>{{productResponse.loadChartList.totalWatt.caseB?productResponse.loadChartList.totalWatt.caseB:''}}
        </td>
      </tr>
    </tbody>
  </table>
  <div *ngIf="productResponse && productResponse.loadChartList">
    <h4 class="pt-3">Recommended battery options and Backup Time</h4>
    <div class="table-responsive ">
      <table  class="table mb-5">
        <thead>
          <tr>
            <th scope="col">Battery</th>
            <th scope="col">Backup Time*(&#64;75% Load) Hrs</th>
            <th scope="col">Backup Time*(&#64;50% Load) Hrs</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="p-0">
              <p scope="col" class="p-4 td-border"
                *ngFor="let battery of productResponse.loadChartList.batteryOptions.valueArray || []">
                {{battery?battery:'N/A'}}
              </p>
            </td>
            <td class="p-0">
              <p scope="col" class="p-4 td-border"
                *ngFor="let backUpData of productResponse.loadChartList.backUpAt75.valueArray || []">
                {{backUpData?backUpData:'N/A'}}
              </p>
            </td>
            <td class="p-0">
              <p scope="col" class="p-4 td-border"
                *ngFor="let backUpData of productResponse.loadChartList.backUpAt50.valueArray || []">
                {{backUpData?backUpData:'N/A'}}
              </p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div *ngIf="productResponse.loadChartList && productResponse.loadChartList.considerations">
    <h4 class="pt-3">Considerations</h4>
    <ul class="cst-table pt-3 ps-0">
      <li class="d-block d-lg-flex align-items-lg-center">
        <h5>{{productResponse.loadChartList.considerations}}</h5>
      </li>
    </ul>
  </div>
</ng-template>

<section class="pdp main-content pt-5" *ngIf="productResponse && showPage">
  <div class="container">
    <div class="row">
      <div class="col-md-5 left-container">
        <!-- Product Image Section for Desktop -->
        <!-- Desktop View -->
        <ng-container *ngIf="utils.screenSizeObj.width > 768 && productResponse">
          <div class="mainImg">
            <picture>
              <source [srcset]="productResponse.featureImageFile || ''" >

              <img *ngIf="isImage(productResponse.featureImageFile)"  loading="eager" width="453" height="auto" [src]="productResponse.featureImageFile || ''" alt={{productResponse.featureImageAltTag}}  (mouseover)="zoomIn($event)" (mousemove)="moveZoom($event)" (mouseout)="zoomOut()">
            </picture>
            <ng-container *ngIf="utils.screenSizeObj.width >= 1366">
             
              <div id="zoom-box" *ngIf="isImage(productResponse.featureImageFile)"
                style="display: none; position: absolute; left: 5px;  z-index: 9999;"></div>
              <div class="video-container" *ngIf="!isImage(productResponse.featureImageFile)">
                <video #videoPlayer (click)="toggleVideoPlay(videoPlayer)" (pause)="isPlayButtonVisible = true"(load)="toggleVideoPlay(videoPlayer)"
                  (ended)="isPlayButtonVisible = true">
                  <source [src]="productResponse.featureImageFile" type="video/mp4">
                  Your browser does not support the video tag.
                </video>
                <div class="playbutton" [ngClass]="{'hidden': !isPlayButtonVisible}">
                  <img [src]="environment.blobUrl+'/assets/videos/playbutton.png'"
                    (click)="toggleVideoPlay(videoPlayer)" alt="Play Button">
                </div>
              </div>

            </ng-container>
          </div>
          <div class="thumbimg d-flex flex-wrap mt-4 justify-content-center">
            <ng-container *ngFor="let item of productResponse.landingPageImages || []">
              <ng-container *ngIf="isVideo(item)">
                <video width="48" height="48" (click)="onClickLandingImages(item)">
                  <source [src]="item" type="video/mp4">
                  Your browser does not support the video tag.
                </video>
              </ng-container>
              <ng-container *ngIf="isImage(item)">
                <div class="mb-2 me-4">
                  <img loading="lazy" [src]="item" alt="Product Image | Luminous" (click)="onClickLandingImages(item)">
                </div>
              </ng-container>
            </ng-container>
          </div>
        </ng-container>
        <!-- Mobile View (Carousel) -->
        <div #carousel *ngIf="utils.screenSizeObj.width <=768 && productResponse"
        class="position-relative pdpImageCarousel">
        <div class="wrapper">
          <owl-carousel-o [options]="customOptions">
            <ng-container *ngFor="let item of productResponse.landingPageImages; let i = index">
              <ng-template carouselSlide>
                <div class="productimgWrap">
                  <ng-container *ngIf="isImage(item)">
                    <!-- Image -->
                    <img loading="lazy" [src]="item" alt="Product Image | Luminous" (click)="showLightbox(i)">
                  </ng-container>
                  <div class="video-container" *ngIf="isVideo(item)">
                    <video #videoPlayer [src]="item" (click)="toggleVideoPlay(videoPlayer)" 
                      (pause)="isPlayButtonVisible = true" (ended)="isPlayButtonVisible = true">
                      Your browser does not support the video tag.
                    </video>
                    <div class="playbutton" [ngClass]="{'hidden': !isPlayButtonVisible}">
                      <img [src]="environment.blobUrl+'/assets/videos/playbutton.png'"
                        (click)="toggleVideoPlay(videoPlayer)" alt="Play Button">
                    </div>
                  </div>
                </div>
              </ng-template>
            </ng-container>
          </owl-carousel-o>
        </div>
      </div>
      </div>
      <div class="col-lg-7 mt-4 right-container">

        <div class="d-flex align-items-center justify-content-between justify-content-lg-start">
          <h1 class="me-5 text-transform-none">{{productResponse?.productName || 'N/A'}}</h1>
          <div class="pdpIcons ms-4 d-flex">
            <span class="me-4 d-lg-inline-block" *ngIf="productResponse.inventory || !utils.getUserPicode()">
              <img *ngIf="productResponse.isWishList==false" class="shareIcon"  loading="lazy" [src]="environment.blobUrl+'/assets/icons/heart.svg'"
              alt="Wishlist Icon | Luminous" (click)="addEditWishList('add')">
              <img *ngIf="productResponse.isWishList==true" class="shareIcon"  loading="lazy" [src]="environment.blobUrl+'/assets/icons/heart-filled.svg'"
                alt="Wishlist Icon | Luminous" (click)="addEditWishList('remove')">
            </span>
            <span>
              <img  loading="lazy" [src]="environment.blobUrl+'/assets/icons/share.svg'" class="shareIcon" (click)="openShareDialog()" alt="Share Icon | Luminous">
            </span>
          </div>
        </div>
        <div class="pdpPricing mt-4">
          <div class="d-flex" id="storePrice">
            <span class="me-3 me-lg-3">₹ {{(productResponse.sellingPrice? (productResponse.sellingPrice -
              productResponse.discount):
              productResponse.productMRP ) | number:'1.2-2'}}</span>
            <span>(Inclusive of all taxes)</span>
          </div>
          <div id="orignalPrice" class="mt-3" *ngIf="productResponse.distributorProductInventoryGuidId">
            <span class="text-decoration-line-through me-3 me-lg-3">
              M.R.P.: ₹ {{(productResponse?productResponse.productMRP:'0' )| number:'1.2-2'}}
            </span>
            <span>Save ₹ {{discountedPrice | number:'1.2-2'}} ({{discountPercentage | number : '1.2-2'}}%)</span>
          </div>
        </div>
        <div *ngIf="(productResponse && showSpan)">
          <div class="snap_emi_txt"> </div>
          <span class="snapmint_lowest_emi_value" attr.data-snapmint-price="{{(productResponse.sellingPrice && productResponse?.distributorProductInventoryGuidId)?  (productResponse.sellingPrice -
              productResponse.discount):
              productResponse.productMRP}}" [attr.data-snapmint-merchant_id]="environment.merchantId"
            data-snapmint-page="products_page"></span>
        </div>
        <span>For more details, visit the <b>Warranty</b> section under <b>Specifications</b>.</span>
        <div class="mt-3">
          <div class="innerHtmlDiv shortDescription" [innerHTML]="productResponse.shortDescription |safehtml"></div>
        </div>
        <div class="variantsProduct"
          *ngIf="utils.screenSizeObj.width < 768 && productResponse.variantList && productResponse.variantList.length">
          <div class="pdpVariants variantsMob mt-5">
            <h4>Variants</h4>
            <div class="d-flex mt-5 ">
              <div *ngFor="let variant of productResponse.variantList; let i=index" class="variantProductBox active"
                (click)="valueEmitted(variant.productName)">
                <div class="variantProductImg"><img  loading="lazy" [src]="variant.featureImageUniqueFileName" alt={{variant.productName}}></div>
                <div class="card-body px-0 w-100 py-4 py-lg-3 text-center">
                  <h5 class="card-title my-0 mx-2 text-transform-none">{{variant.productName | truncateStr:[15]}}</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="productResponse.inventory > 0" class="pdpQty d-flex align-items-center mt-3 pt-3">
          <span class="me-5">Quantity</span>
          <div id="addRemove">
            <span (click)="decreaseQuantity()">
              <img *ngIf="productQuantity"  loading="lazy" [src]="environment.blobUrl+'/assets/icons/decrement-active.svg'" alt="DecrementActive | Luminous">
              <img *ngIf="productQuantity==0"  loading="lazy" [src]="environment.blobUrl+'/assets/icons/decrement.svg'" alt="Decrement | Luminous">
            </span>
            <span class="user-select-none">{{productQuantity?productQuantity: 0}}</span>
            <span (click)="increaseQuantity()">
              <img  loading="lazy" [src]="environment.blobUrl+'/assets/icons/increment.svg'" alt="Increment | Luminous">
            </span>
          </div>
        </div>

        <div class="d-flex mt-3  align-items-center" *ngIf="utils.getUserPicode()"
          [ngClass]="{'mt-5':utils.getUserPicode()}">
          <span>Delivery Pincode</span>
          <div class="d-flex ms-5 align-items-center">
            <span type="text" class="me-3">{{utils.getUserPicode()}}</span>
            <span role="button" class="greyBtn" (click)="openLocationDialog()">Change</span>
          </div>
        </div>
        <div class="d-flex mt-5  align-items-center" *ngIf="!utils.getUserPicode()">
          <span class="me-5">Enter pincode to see product availability</span>
          <div >
            <span class="add-pincode nextarrow" role="button" (click)="openLocationDialog()">Add a pincode
            </span>
          </div>
        </div>
        <!-- <p class="not-available" *ngIf="!isProductAvailable">Product not available for this Pincode</p> -->
        <div class="d-flex flex-column mt-5" *ngIf='utils.getUserPicode()'
          [ngClass]="!productResponse.inventory? 'pdpOutOfStock': 'pdpStock'">
          <span>{{productResponse.inventory?"In Stock": 'Out of Stock'}}</span>
          <span *ngIf="productResponse.inventory" class="mt-1 deliverySLA">Delivery by
            {{productResponse?.deliverySLA
            | date}}</span>
        </div>

        <div class="mt-5" *ngIf="utils.screenSizeObj.width <= 768">
          <div class="d-flex justify-content-between align-items-center">
            <button *ngIf="productResponse.inventory || !utils.getUserPicode()" class="greyBtn pdpButton" id="addtocart"
              (click)="addToCart()">
              <img  loading="lazy" [src]="environment.blobUrl+'/assets/icons/cart.svg'" alt="Add To Cart | Luminous"> Add to Cart
            </button>
            <button *ngIf="!productResponse.inventory && utils.getUserPicode()" (click)="openDialog()"
              class="greyBtn pdpButton" id="addtocart">
              <img  loading="lazy" [src]="environment.blobUrl+'/assets/icons/cart.svg'" alt="Add To Cart | Luminous"> Notify Me
            </button>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <ng-container *ngTemplateOutlet="buyNow">
            </ng-container>
          </div>
        </div>
        <div class="mt-5" *ngIf="utils.screenSizeObj.width > 768">
          <button class="greyBtn pdpButton" *ngIf="productResponse.inventory || !utils.getUserPicode()" id="addtocart"
            (click)="addToCart()">
            <img  loading="lazy" [src]="environment.blobUrl+'/assets/icons/cart.svg'" alt="Add To Cart | Luminous"> Add to Cart
          </button>
          <button *ngIf="!productResponse.inventory && utils.getUserPicode()" (click)="openDialog()"
            class="greyBtn pdpButton" id="addtocart">
            <img  loading="lazy" [src]="environment.blobUrl+'/assets/icons/cart.svg'" alt="Add To Cart | Luminous"> Notify Me
          </button>
          <ng-container *ngTemplateOutlet="buyNow">
          </ng-container>
          <button class="pdpButton" id="nearbyStore" *ngFor="let data of productResponse.sellingOption;let i=index"
            [hidden]="!data.isActive || data.availableAt=='eshop'" (click)="redirectTo(data)">
            <img loading="lazy"
              [src]="data.availableAt?getDataByAvailableAt(data.availableAt).image : environment.blobUrl+'/assets/images/product-placeholder.svg'"
              (error)="this.src='{{environment.blobUrl}}/assets/images/product-placeholder.svg'" alt="Buy From Flipkart | Luminous">
            {{data.availableAt?getDataByAvailableAt(data.availableAt).name : ''}}
            <img  loading="lazy" [src]="environment.blobUrl+'/assets/icons/arrow.svg'" alt="Find At A Nearby Store | Luminous">
          </button>
        </div>
        <div class="variantsProduct"
          *ngIf="utils.screenSizeObj.width > 768 && productResponse.variantList && productResponse.variantList.length">
          <div class="pdpVariants mt-5">
            <h4>Variants</h4>
            <div class="d-flex mt-5">
              <div *ngFor="let variant of productResponse.variantList; let i=index" class="variantProductBox active"
                [class.active]="selectedVariantIndex === i" (click)="setVariantIndex(i)"
                (click)="valueEmitted(variant.productName)">
                <div class="variantProductImg w-100">
                  <img  loading="lazy" [src]="variant.featureImageUniqueFileName" alt={{variant.productName}}>
                </div>
                <div class="card-body px-0 w-100 py-4 py-lg-3 text-center">
                  <h5 class="card-title my-0 mx-2">{{variant.productName | truncateStr:[20]}}</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-5" *ngIf="utils.screenSizeObj.width <= 768">
          <div *ngFor="let data of productResponse.sellingOption;let i=index"
            [hidden]="data.isActive || data.availableAt=='eshop'">
            <button class="pdpButton" id="nearbyStore" (click)="redirectTo(data)">
              <img loading="lazy"
                [src]="data.availableAt?getDataByAvailableAt(data.availableAt).image : environment.blobUrl+'/assets/images/product-placeholder.svg'"
                (error)="this.src=environment.blobUrl+'/assets/images/product-placeholder.svg'" alt="Buy From Flipkart | Luminous">
              {{data.availableAt?getDataByAvailableAt(data.availableAt).name : ''}}
              <img  loading="lazy" [src]="environment.blobUrl+'/assets/icons/arrow.svg'" alt="Find At A Nearby Store | Luminous">
            </button>
          </div>
        </div>

      </div>
    </div>
  </div>

  <div class="d-block d-lg-none">
    <mat-accordion class="mobile-tabs">
      <mat-expansion-panel *ngIf="productResponse && productResponse.productOverview">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h5>Overview</h5>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div *ngIf="productResponse && productResponse.productOverview" class="overView pt-3">
          <div class="innerHtmlDiv" [innerHTML]="(productResponse?.productOverview.overView) | safehtml"></div>
        </div>
      </mat-expansion-panel>
      <mat-expansion-panel
        *ngIf="(productResponse && productResponse.loadChartList) ||  (productResponse && productResponse.appliances && productResponse.appliances.length)">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h5>Load Chart</h5>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div>
          <ng-container *ngTemplateOutlet="loadChart">
          </ng-container>
        </div>
      </mat-expansion-panel>
      <mat-expansion-panel
        *ngIf="productResponse && productResponse.specificationList && productResponse.specificationList.length && checkVisibility( productResponse.specificationList)">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h5>Specifications</h5>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div>
          <ul class="cst-table pt-3 ps-0">
            <li class="d-block d-lg-flex align-items-lg-center"
              *ngFor="let info of productResponse?.specificationList || []"
              [ngClass]="{'d-none d-lg-none':!info.value || !valueTrimAndCheckVisibility(info.value)}">
              <h5>{{info.description}} </h5>
              <p *ngIf="info.description !=='Warranty'" class="pt-2">{{info.value?info.value:''}}</p>
              <div *ngIf="info?.description=='Warranty' ">
                <p class="pt-2">{{info.value?info.value:''}}</p>
                <a *ngIf="productResponse?.productOverview?.warrantyDocUniqueFileName" class="warranty-button" target="_blank" [href]="productResponse?.productOverview?.warrantyDocUniqueFileName" alt="PDF | Luminous">View Warranty Information <img loading="lazy" class="pdf-image" src="{{environment.blobUrl}}/assets/icons/pdf.webp" alt="PDF | Luminous"></a>
              </div>
            </li>
          </ul>
        </div>
      </mat-expansion-panel>
      <mat-expansion-panel
        *ngIf="productResponse && productResponse.maufacturerList && productResponse.maufacturerList.length && checkVisibility( productResponse.maufacturerList)">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h5>Manufacturer information</h5>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div>
          <ul class="cst-table pt-3 ps-0">
            <li class="d-block d-lg-flex align-items-lg-center "
              *ngFor="let info of productResponse?.maufacturerList || []"
              [ngClass]="{'d-none d-lg-none':!info.value || !valueTrimAndCheckVisibility(info.value)}">
              <h5>{{info.description}} </h5>
              <p class="pt-2">{{info.value?info.value:''}}</p>
            </li>
          </ul>
        </div>
      </mat-expansion-panel>
      <mat-expansion-panel
        *ngIf="productResponse && productResponse.questionAnswer && productResponse.questionAnswer.length">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h5>FAQs</h5>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <app-faq-page [faqData]="productResponse.questionAnswer" *ngIf="productResponse != undefined"></app-faq-page>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
  <div class="pdpTab mt-5 d-none d-lg-block">
    <div class="nav-tab-container">
      <ul class="nav nav-tabs">
        <li class="nav-item">
          <a class="nav-link" [class.active]="activeTab === 'overview'" (click)="setActiveTab('overview')" data-bs-toggle="tab" *ngIf="productResponse && productResponse.productOverview">Overview</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [class.active]="activeTab === 'load-chart'" (click)="setActiveTab('load-chart')" data-bs-toggle="tab" *ngIf="productResponse && ((productResponse.loadChartList && productResponse.loadChartList) || (productResponse.appliances && productResponse.appliances.length))">Load Chart</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [class.active]="activeTab === 'specifications'" (click)="setActiveTab('specifications')" data-bs-toggle="tab" *ngIf="productResponse && productResponse.specificationList && productResponse.specificationList.length && checkVisibility(productResponse.specificationList)">Specifications</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [class.active]="activeTab === 'manufacturer-info'" (click)="setActiveTab('manufacturer-info')" data-bs-toggle="tab" *ngIf="productResponse && productResponse.maufacturerList && productResponse.maufacturerList.length && checkVisibility(productResponse.maufacturerList)">Manufacturer information</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [class.active]="activeTab === 'faqs'" (click)="setActiveTab('faqs')" data-bs-toggle="tab" *ngIf="productResponse && productResponse.questionAnswer && productResponse.questionAnswer.length">FAQs</a>
        </li>
      </ul>
    </div>
  
    <div class="tab-content">
      <div class="tab-pane fade" [ngClass]="{'show active': activeTab === 'overview'}" id="overview">
        <div class="innerHtmlDiv">
          <div class="example-small-box overView" *ngIf="productResponse && productResponse.productOverview">
            <div class="innerHtmlDiv" [innerHTML]="(productResponse?.productOverview.overView ) | safehtml"></div>
          </div>
        </div>
      </div>
  
      <div class="tab-pane fade" [ngClass]="{'show active': activeTab === 'load-chart'}" id="load-chart">
        <ng-container *ngTemplateOutlet="loadChart"></ng-container>
      </div>
  
      <div class="tab-pane fade" [ngClass]="{'show active': activeTab === 'specifications'}" id="specifications">
        <ul class="cst-table">
          <ng-container *ngFor="let info of productResponse?.specificationList || []">
            <li *ngIf="info.value !== 'N/A'" class="d-block d-lg-flex align-items-lg-center"
              [ngClass]="{'d-none d-lg-none':!info.value || !valueTrimAndCheckVisibility(info.value)}">
              <h5>{{info.description}} </h5>
              <p *ngIf="info.description !== 'Warranty'" class="pt-2">{{info.value ? info.value : ''}}</p>
              <div *ngIf="info?.description == 'Warranty'">
                <p class="pt-2">{{info.value ? info.value : ''}}</p>
                <a *ngIf="productResponse?.productOverview?.warrantyDocUniqueFileName" class="warranty-button" target="_blank" [href]="productResponse?.productOverview?.warrantyDocUniqueFileName" alt="PDF | Luminous">View Warranty Information <img loading="lazy" class="pdf-image" src="{{environment.blobUrl}}/assets/icons/pdf.webp" alt="PDF | Luminous"></a>
              </div>
            </li>
          </ng-container>
        </ul>
      </div>
  
      <div class="tab-pane fade" [ngClass]="{'show active': activeTab === 'manufacturer-info'}" id="manufacturer-info">
        <ul class="cst-table">
          <ng-container *ngFor="let info of productResponse?.maufacturerList || []">
            <li *ngIf="info.value !== 'N/A'" class="d-block d-lg-flex align-items-lg-center"
              [ngClass]="{'d-none d-lg-none':!info.value || !valueTrimAndCheckVisibility(info.value)}">
              <h5>{{info.description}} </h5>
              <p>{{info.value ? info.value : ''}}</p>
            </li>
          </ng-container>
        </ul>
      </div>
  
      <div class="tab-pane fade" [ngClass]="{'show active': activeTab === 'faqs'}" id="faqs">
        <app-faq-page [faqData]="productResponse.questionAnswer"></app-faq-page>
      </div>
    </div>
  </div>
  
  <!-- <div class="pdpTab mt-5 d-none d-lg-block">
    <mat-tab-group dynamicHeight animationDuration="0ms">
      <mat-tab label="Overview" *ngIf="productResponse && productResponse.productOverview">
        <div class="example-small-box overView" *ngIf="productResponse && productResponse.productOverview">
          <div class="innerHtmlDiv" [innerHTML]="(productResponse?.productOverview.overView ) |safehtml"></div>
        </div>
      </mat-tab>
      <mat-tab label="Load Chart"
        *ngIf="productResponse && ((productResponse.loadChartList && productResponse.loadChartList) ||(productResponse.appliances && productResponse.appliances.length)) ">
        <ng-container *ngTemplateOutlet="loadChart">
        </ng-container>
      </mat-tab>

      <mat-tab label="Specifications"
        *ngIf="productResponse && productResponse.specificationList && productResponse.specificationList.length && checkVisibility( productResponse.specificationList)">
        <ul class="cst-table">
          <ng-container *ngFor="let info of productResponse?.specificationList || []">
            <li *ngIf="info.value !== 'N/A'" class="d-block d-lg-flex align-items-lg-center"
            [ngClass]="{'d-none d-lg-none':!info.value || !valueTrimAndCheckVisibility(info.value)}">
              <h5>{{info.description}} </h5>
              <p *ngIf="info.description !=='Warranty'" class="pt-2">{{info.value?info.value:''}}</p>
                <div *ngIf="info?.description=='Warranty' ">
                  <p class="pt-2">{{info.value?info.value:''}}</p>
                  <a *ngIf="productResponse?.productOverview?.warrantyDocUniqueFileName" class="warranty-button" target="_blank" [href]="productResponse?.productOverview?.warrantyDocUniqueFileName" alt="PDF | Luminous">View Warranty Information <img loading="lazy" class="pdf-image" src="{{environment.blobUrl}}/assets/icons/pdf.webp" alt="PDF | Luminous"></a>
                </div>
            </li>
          </ng-container>
        </ul>
      </mat-tab>
      <mat-tab label="Manufacturer information"
        *ngIf="productResponse && productResponse.maufacturerList && productResponse.maufacturerList.length && checkVisibility( productResponse.maufacturerList)">
        <ul class="cst-table">
          <ng-container  *ngFor="let info of productResponse?.maufacturerList || []">
            <li *ngIf="info.value !== 'N/A'" class="d-block d-lg-flex align-items-lg-center"
            [ngClass]="{'d-none d-lg-none':!info.value || !valueTrimAndCheckVisibility(info.value)}">
              <h5>{{info.description}} </h5>
              <p>{{info.value?info.value:''}}</p>
            </li>
          </ng-container>
        </ul>
      </mat-tab>
      <mat-tab label="FAQs"
        *ngIf="productResponse && productResponse.questionAnswer && productResponse.questionAnswer.length">
        <app-faq-page [faqData]="productResponse.questionAnswer"></app-faq-page>
      </mat-tab>
    </mat-tab-group>
  </div> -->
  <div class="pdpRvw border-top"
    *ngIf="productResponse.reviewData && productResponse.reviewData.overAll &&  productResponse.reviewData.overAll.length">
    <app-all-reviews [reviewData]="productResponse.reviewData" [productGuidId]="productGuidId" [pageName]="pageName"
      [productName]="productResponse.productName"></app-all-reviews>
  </div>
  <div class="pdpFeatured py-5 border-bottom border-top"
    *ngIf="productResponse.similarProduct && productResponse.similarProduct.length">
    <div class="container">
      <h3 class="mb-5">Similar products</h3>
      <div>
        <app-carousal-page [isPDPCarousel]="true" [carouselSlideData]="productResponse.similarProduct"
          [isProductCarousel]="true">
        </app-carousal-page>
      </div>
    </div>
  </div>
  <div class="pdpFeatured py-5 bgWhite"
    *ngIf="productResponse.frequentlyBoughtTogether && productResponse.frequentlyBoughtTogether.length">
    <div class="container">
      <h3 class="mb-5">Frequently bought together</h3>
      <div>
        <app-carousal-page [frequentlyBought]="true" [carouselSlideData]="productResponse.frequentlyBoughtTogether"
          [isProductCarousel]="true">
        </app-carousal-page>
      </div>
    </div>
  </div>
</section>
<!-- <ng-image-fullscreen-view *ngIf="utils.screenSizeObj.width <= 768" [images]="imageObject"
  [imageIndex]="selectedImageIndex" [show]="showFlag" (close)="closeEventHandler()"></ng-image-fullscreen-view> -->
<!-- Fullscreen modal to show the selected image -->
<div *ngIf="showFlag" class="fullscreen-modal">
  <button (click)="closeEventHandler()" class="close-button">X</button>
  <div class="fullscreen-content">
    <!-- Conditionally display image or video based on media type -->
    <ng-container *ngIf="isImage(imageObject[selectedImageIndex])">
      <img loading="lazy" [src]="imageObject[selectedImageIndex]" alt="Fullscreen Image" />
    </ng-container>
    <ng-container *ngIf="!isImage(imageObject[selectedImageIndex])">

      <div class="video-container" *ngIf="isVideo(imageObject[selectedImageIndex])">
        <video #videoPlayer [src]="imageObject[selectedImageIndex]" (click)="toggleVideoPlay(videoPlayer)"
          (pause)="isPlayButtonVisible = true" (ended)="isPlayButtonVisible = true">
          Your browser does not support the video tag.
        </video>
        <div class="playbutton" [ngClass]="{'hidden': !isPlayButtonVisible}">
          <img [src]="environment.blobUrl+'/assets/videos/playbutton.png'"
            (click)="toggleVideoPlay(videoPlayer)" alt="Play Button">
        </div>
      </div>
     </ng-container>
    <!-- Navigation buttons -->
    <button (click)="showPrevImage()" [disabled]="selectedImageIndex === 0"
      class="owl-nav d-flex justify-content-center align-items-center owl-prev"> 
      <svg class="custom-icon"
        xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 40 40" focusable="false"
        aria-hidden="true" data-di-res-id="ca1abdf8-d437167" data-di-rand="1725952672698">
        <g fill="none" fill-rule="evenodd">
          <g>
            <circle cx="20" cy="20" r="20"></circle>
            <g fill-rule="nonzero">
              <path d="M15.179 3.173L16.043 4.077 7.765 12 16.043 19.923 15.179 20.827 5.957 12z"
                transform="translate(8 8)" fill="#ffffff"></path>
            </g>
          </g>
        </g>
      </svg>
    </button>
    <button (click)="showNextImage()" [disabled]="selectedImageIndex === imageObject.length - 1"
      class="owl-nav d-flex justify-content-center align-items-center owl-next"> 
      <svg class="custom-icon"
        xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 40 40" focusable="false"
        aria-hidden="true" data-di-res-id="72a6da9d-f8bd046d" data-di-rand="1725952672699">
        <g>
          <circle cx="20" cy="20" r="20"></circle>
          <g fill-rule="nonzero">
            <path d="M7.957 4.077L8.821 3.173 18.043 12 8.821 20.827 7.957 19.923 16.235 12z" transform="translate(8 8)"
              fill="#ffffff"></path>
          </g>
        </g>
      </svg> 
    </button>
  </div>
</div>
  <!-- Thumbnails or Image List -->
  <div *ngFor="let image of imageObject; let i = index" (click)="showLightbox(i)">
    <img [src]="image.src" alt="Thumbnail Image" />
  </div>